module.exports = __webpack_public_path__ + "img/speaker.64390c68.svg";